import React, { FC, ReactNode } from 'react';
import s from './Modal.module.scss';

type DescriptionProps = {
  children: ReactNode;
};

const Description: FC<DescriptionProps> = ({ children }) => (
  <p className={s.description}>
    {children}
  </p>
);

export default Description;
